import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { get, head, includes, filter, isEmpty } from 'lodash'
import { LinkContainer } from 'react-router-bootstrap'
import window from 'browser-lib/window'

import { clearSignedInApp } from '@scoir/redirects'
import HeaderNavigation from './PageFrameHeaderNavigation'
import { imageAsFullImageSrc } from '@scoir/avatar-image-url'
import { HeightTracker } from '@scoir/college-details'

import api from 'common/api'
import { removeBearerToken } from 'common/bearer'
import userPermissions from 'common/system-permissions'
import { actions as mapFilterActions } from 'store/map-filters'
import collegeFeatures from 'common/college-features'
import permissions from 'common/system-permissions'
import features from 'common/college-features'

import { hasPermission } from 'store/user'
import { isFeatureEnabled } from 'store/college'
import withContext from 'components/RealtimeMessagingProvider/withContext'
import DirectMessaging from './DirectMessaging'
import { isAPIActive, isDownload, isSFTPSlate, isSFTPActive } from 'common/integrations-helpers'
import { isHighSchoolExplorerEnabled } from 'store/user'

const onlyIfSubItemsExist = (config) => !isEmpty(config.subItems) && config

export const TOP_NAVIGATION_HEIGHT_ID = 'top-navigation'

export class AdmissionsHeaderNavigation extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    integrations: PropTypes.object,
    scid: PropTypes.number,
    updateFilters: PropTypes.func.isRequired,
    documentDelegateName: PropTypes.string,
    realtimeConnect: PropTypes.func.isRequired,
    realtimeLogout: PropTypes.func.isRequired,
    collegeName: PropTypes.string.isRequired,
    supportsEndOfCycleReport: PropTypes.bool.isRequired,
    supportsCrmIntegration: PropTypes.bool.isRequired,
    applicationIntegrationsEnabled: PropTypes.bool.isRequired,
    applicationActivationEnabled: PropTypes.bool.isRequired,
    scoirApplyEnabled: PropTypes.bool.isRequired,
    isShadow: PropTypes.bool.isRequired,
    showHighSchoolExplorer: PropTypes.bool.isRequired,
  }
  static defaultProps = {
    supportsEndOfCycleReport: false,
    integrations: {},
  }
  hasPermission(key) {
    return includes(this.props.user.Permissions, userPermissions[key])
  }
  render() {
    const {
      realtimeConnect,
      realtimeLogout,
      user,
      scid,
      documentDelegateName,
      updateFilters,
      collegeName,
      supportsEndOfCycleReport,
      supportsCrmIntegration,
      applicationIntegrationsEnabled,
      applicationActivationEnabled,
      scoirApplyEnabled,
      isShadow,
      integrations,
      showHighSchoolExplorer,
    } = this.props
    const ROOT = import.meta.env.BASE_URL
    const canManage = this.hasPermission('MANAGE_ADMISSIONS')
    const canViewApplicants = this.hasPermission('VIEW_APPLICANTS')
    const canManageApplicationRounds = this.hasPermission('MANAGE_COLLEGE_APPLICATION_ROUNDS')
    const canManageNoDocumentDelegate = canManage && !documentDelegateName
    const canRecruit = this.hasPermission('PERFORM_VISIT_MANGEMENT_TASKS')
    const canAdmissions = this.hasPermission('PERFORM_ADMISSIONS_TASKS')
    const canSearch = this.hasPermission('PERFORM_COLLEGE_SEARCH')
    const canConfigureApplicationIntegration = applicationIntegrationsEnabled || isShadow
    const canActivateApplications = (applicationIntegrationsEnabled && applicationActivationEnabled) || isShadow
    const canViewAppExtensions = (scoirApplyEnabled && canManageApplicationRounds) || isShadow
    const hasDeliveryPreferences =
      isDownload(integrations) ||
      isAPIActive(integrations) ||
      (isSFTPActive(integrations) && !isSFTPSlate(integrations))

    const menuItems = filter([
      {
        path: `${ROOT}/dashboard`,
        label: 'Dashboard',
      },
      {
        path: `${ROOT}/colleges`,
        label: 'School Profile',
        subItems: filter([
          {
            path: `${ROOT}/colleges/${scid}`,
            label: 'My College',
          },
          canSearch && {
            path: `${ROOT}/colleges/search`,
            label: 'Search',
          },
        ]),
      },
      {
        path: `${ROOT}/application`,
        label: 'Application',
        subItems: filter([
          canViewApplicants && {
            path: `${ROOT}/application/applicants`,
            label: 'Applicants',
          },
          {
            path: `${ROOT}/application/rounds`,
            label: 'Set Rounds',
          },
          canConfigureApplicationIntegration && {
            path: `${ROOT}/application/settings`,
            label: 'Configure',
          },
          canActivateApplications && {
            path: `${ROOT}/application/integration`,
            label: 'Activate',
          },
          canViewAppExtensions && {
            path: `${ROOT}/application/extensions`,
            label: 'Extensions',
          },
        ]),
      },
      canRecruit &&
        !showHighSchoolExplorer && {
          path: `${ROOT}/recruit`,
          label: 'High School Visits',
          subItems: [
            {
              path: `${ROOT}/recruit/explore`,
              label: 'Map',
            },
            {
              path: `${ROOT}/recruit/visits`,
              label: 'Calendar',
            },
          ],
        },
      canRecruit &&
        showHighSchoolExplorer && {
          path: `${ROOT}/recruit`,
          label: 'High Schools',
          subItems: [
            {
              path: `${ROOT}/recruit/highschools`,
              label: 'Explore',
            },
            {
              path: `${ROOT}/recruit/visits`,
              label: 'Calendar',
            },
          ],
        },
      onlyIfSubItemsExist({
        label: 'Engage',
        path: `${ROOT}/engage`,
        subItems: filter([
          {
            path: `${ROOT}/engage/presence`,
            label: 'Presence',
          },
          {
            path: `${ROOT}/engage/messaging`,
            label: 'Messaging',
          },
          supportsCrmIntegration && {
            path: `${ROOT}/engage/integrations`,
            label: 'Integrations',
          },
          supportsEndOfCycleReport && {
            path: `${ROOT}/engage/end-of-cycle-report`,
            label: 'End Of Cycle Report',
          },
        ]),
      }),
      (canAdmissions || canManageNoDocumentDelegate) && {
        path: `${ROOT}/documents`,
        label: 'Documents',
        subItems: filter([
          canAdmissions && {
            path: `${ROOT}/documents/batches/daily`,
            label: 'Batches',
          },
          canAdmissions && {
            path: `${ROOT}/documents/batches/applicants`,
            label: 'Historical Applicants',
          },
          canAdmissions &&
            !documentDelegateName &&
            hasDeliveryPreferences && {
              path: `${ROOT}/documents/delivery/preferences`,
              label: 'Delivery Preferences',
            },
          canManageNoDocumentDelegate && {
            path: `${ROOT}/documents/integrations`,
            label: 'Configure Integrations',
          },
        ]),
      },
    ])
    const settingsItems = filter([
      {
        path: `${ROOT}/my/profile/info`,
        label: 'Personal profile',
      },
      canManage && {
        path: `${ROOT}/org/users`,
        label: 'Users',
      },
      {
        label: 'Support',
        onClick: () => {
          window.open('https://scoir.helpdocs.io/category/j5gu4xhb9p-college-admissions')
        },
      },
      {
        onClick: () => {
          api.get('/api/logout').finally(() => {
            updateFilters({})
            clearSignedInApp('admissions')
            removeBearerToken()
            window.location.assign(`/logout?userType=${head(user.UserTypes)}`)
            realtimeLogout()
          })
        },
        label: 'Sign out',
      },
    ])
    return (
      <HeightTracker id={TOP_NAVIGATION_HEIGHT_ID}>
        <HeaderNavigation.TieredNavigation
          scoirLogoDestination={`${ROOT}/home`}
          organizationName={collegeName}
          userAvatarUrl={user.AvatarUrl && imageAsFullImageSrc(user.AvatarUrl)}
          userName={user.FirstName}
          messagingComponent={<DirectMessaging />}
          inboxComponent={
            <LinkContainer to={`${ROOT}/message-center/notifications`}>
              <HeaderNavigation.TieredNavigation.NotificationsIndicator
                realtimeUpLinkFn={(cb) => realtimeConnect(`${user.Id}-Notifications`, cb)}
                onFetchUnreadCount={() => api.get('/api/inbox?start=0&pageSize=1').then((inbox) => inbox.UnreadCount)}
              />
            </LinkContainer>
          }
          menuItems={menuItems}
          settingsItems={settingsItems}
        />
      </HeightTracker>
    )
  }
}

const RealtimeMessagingConnected = withContext({
  logout: 'realtimeLogout',
  connect: 'realtimeConnect',
})(AdmissionsHeaderNavigation)

export default connect(
  (store) => ({
    user: store.user.record,
    collegeName: get(store.college.record, 'Name'),
    scid: get(store.college.record, 'Scid'),
    supportsEndOfCycleReport:
      isFeatureEnabled(store, collegeFeatures.SUPPORTS_CRM_MATCHING_REPORT) &&
      hasPermission(store, permissions.MANAGE_CRM_UPLOADS),
    documentDelegateName: get(store.college.record, 'Integrations.DocumentDelegateName', ''),
    supportsCrmIntegration: !!get(store, `college.record.Features.${features.CRM_INTEGRATION}`),
    applicationIntegrationsEnabled: !!get(store, `college.record.Features.${features.APPLICATION_INTEGRATION}`),
    applicationActivationEnabled: !!get(store, `college.record.Features.${features.APPLICATION_ACTIVATION}`),
    scoirApplyEnabled: !!get(store, `college.record.ScoirApplyEnabled`),
    isShadow: get(store.user.record, 'IsShadow', false),
    showHighSchoolExplorer: isHighSchoolExplorerEnabled(store),
  }),
  {
    updateFilters: mapFilterActions.updateFilters,
  },
)(RealtimeMessagingConnected)
